import React from 'react';
var ComparisonBarChartMobile = function (props) {
    var chartConfig = {
        barHeight: 1.75, // in rem
        verticalLineWidth: 1
    };
    var value = props.value, maxValue = props.maxValue, displayTextValue = props.displayTextValue;
    var maxBarChartPercentage = 30;
    var barChartPercentage = (Math.abs(value) * maxBarChartPercentage) / maxValue;
    var verticalLineX = 50 - chartConfig.verticalLineWidth / 2;
    var comparedPercentX = value > 0 ? 50 : 50 - barChartPercentage;
    var backgroundColorClassName = value > 0 ? 'u-els-fill-extended-green-8' : 'u-els-fill-warn';
    return (<div className="c-comparison-bar-chart">
      <svg className="u-els-display-block" width="100%" height={"".concat(chartConfig.barHeight, "rem")}>
        <g>
          <rect width={"".concat(100, "%")} height={"".concat(chartConfig.barHeight, "rem")} className="u-els-fill-n2"/>
          <rect x={"".concat(comparedPercentX, "%")} width={"".concat(barChartPercentage, "%")} height={"".concat(chartConfig.barHeight, "rem")} className={backgroundColorClassName}/>
          <rect x={"".concat(verticalLineX, "%")} width={"".concat(chartConfig.verticalLineWidth, "%")} height={"".concat(chartConfig.barHeight, "rem")} className="u-els-fill-n8"/>
        </g>
      </svg>
      <div className="c-comparison-bar-chart__description">
        <span className="c-table-card__table-row-header">Performance Compared to Class Avg</span>
        <span className="c-table-card__table-row-content">
          <span>{displayTextValue}</span>
        </span>
      </div>
    </div>);
};
export default ComparisonBarChartMobile;
